import {InspectedDatabasePage} from '../modules/InspectedDatabase';

export default InspectedDatabasePage;
